/**
 * theme.js — clair ou sombre
 *
 * Le panel n'existait qu'en sombre. Le choix tient dans le navigateur plutôt
 * que dans les paramètres du serveur : c'est une préférence d'affichage, elle
 * n'a pas à être la même pour tout le monde sur le même compte.
 *
 * Il s'applique avant le premier rendu — sinon la page s'affiche en sombre une
 * fraction de seconde avant de basculer, et ça se voit.
 */

const CLE = 'admin_theme';
export const THEMES = [
  { id: 'sombre', label: 'Sombre' },
  { id: 'clair', label: 'Clair' },
  { id: 'systeme', label: 'Comme le système' },
];

/** Le thème choisi, tel qu'il est enregistré. */
export function themeChoisi() {
  try {
    const v = localStorage.getItem(CLE);
    return THEMES.some(t => t.id === v) ? v : 'sombre';
  } catch { return 'sombre'; }
}

/** Le thème réellement affiché : « systeme » se résout ici. */
export function themeEffectif(choix = themeChoisi()) {
  if (choix !== 'systeme') return choix;
  try {
    return window.matchMedia('(prefers-color-scheme: light)').matches ? 'clair' : 'sombre';
  } catch { return 'sombre'; }
}

/** Pose l'attribut que lit la feuille de style. */
export function appliquerTheme(choix = themeChoisi()) {
  const effectif = themeEffectif(choix);
  // Le sombre est la valeur par défaut des jetons : pas d'attribut à poser.
  if (effectif === 'clair') document.documentElement.setAttribute('data-theme', 'clair');
  else document.documentElement.removeAttribute('data-theme');
  return effectif;
}

/** Enregistre et applique. */
export function definirTheme(choix) {
  try { localStorage.setItem(CLE, choix); } catch { /* navigation privée */ }
  return appliquerTheme(choix);
}

/**
 * Suit le réglage du système, tant que l'utilisateur a choisi « systeme ».
 * Rend la fonction de désabonnement.
 */
export function suivreSysteme() {
  try {
    const mq = window.matchMedia('(prefers-color-scheme: light)');
    const quand = () => { if (themeChoisi() === 'systeme') appliquerTheme('systeme'); };
    mq.addEventListener('change', quand);
    return () => mq.removeEventListener('change', quand);
  } catch { return () => {}; }
}
